import { Modal, Box, Button, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const KnowledgeLimitInfoModal = ({ open, onClose, onUpgrade, remainingSlots = 0 }) => {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        outline: "none",
        zIndex: 1400,
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "28px 24px",
          width: "100%",
          maxWidth: "420px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          outline: "none",
          position: "relative",
          textAlign: "center",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "text.secondary",
            "&:hover": { color: "text.primary" },
          }}
          aria-label={t("close")}
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>

        <FontAwesomeIcon
          icon={faTriangleExclamation}
          style={{ fontSize: "36px", color: "#f59e0b", marginBottom: "12px" }}
        />

        <h3 style={{ margin: "0 0 8px 0", fontSize: "18px", fontWeight: 600, color: "#111827" }}>
          {t("knowledge_source_limit_title")}
        </h3>

        <p style={{ margin: "0 0 20px 0", color: "#666", fontSize: "14px", lineHeight: 1.5 }}>
          {remainingSlots === 0
            ? t("knowledge_limit_reached_zero")
            : t("knowledge_limit_remaining", { count: remainingSlots })}
        </p>

        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              color: "#5616ea",
              borderColor: "#5616ea",
              "&:hover": { borderColor: "#4915cc", backgroundColor: "#f3eaff" },
            }}
          >
            {t("go_back")}
          </Button>
          {onUpgrade && (
            <Button
              onClick={onUpgrade}
              variant="contained"
              sx={{
                backgroundColor: "#5616ea",
                "&:hover": { backgroundColor: "#4915cc" },
              }}
            >
              {t("upgrade_plan")}
            </Button>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default KnowledgeLimitInfoModal;
